import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const CustomLogout = () => {
  const navigate = useNavigate();
  const handleLoginAgain = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f0f2f5",
      }}
    >
      <Result
        status="success"
        title="Successfully Logged Out"
        subTitle="You have been successfully logged out of your account."
        extra={[
          <Button type="primary" key="login" onClick={handleLoginAgain}>
            Login Again
          </Button>,
        ]}
      />
    </div>
  );
};

export default CustomLogout;